var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"mb-3"},[_vm._v("Log")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.log_headers,"items":_vm.log_items,"item-key":"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }